import React, { useState, useEffect } from "react";
import "./user-feedback-styles.css";
import InfoIcon from "../../assets/icons/information-circle-outline.svg";
import InfoIconDark from "../../assets/icons/information-circle-outline-dark.svg";
import ErrorIcon from "../../assets/icons/bug-outline.svg";
import ErrorIconDark from "../../assets/icons/bug-outline-dark.svg";
import CloseIcon from "../../assets/icons/close.svg";
import CloseIconDark from "../../assets/icons/close-dark.svg";
import useThemeImage from "../../hooks/useThemeImage";
import { Loading } from "../loading/Loading";

const UserFeedback = ({ message, title, type }) => {
  const [isExiting, setIsExiting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const themeImage = useThemeImage(InfoIcon, InfoIconDark);
  const themeClose = useThemeImage(CloseIcon, CloseIconDark);
  const themeError = useThemeImage(ErrorIcon, ErrorIconDark);
  const onClose = () => {
    setIsExiting(true);
  };

  const handleExit = () => {
    setIsExiting(true);
    onClose();
  };

  useEffect(() => {
    if (type === "success") {
      setIsSuccess(true);
    }

    if (type === "error") {
      setIsError(true);
    }

    if (type === "loading") {
      setIsLoading(true);
    }
  }, [type]);

  return (
    <div
      className={`user-feedback-container ${isExiting ? "exit" : ""}`}
      style={{
        borderLeft: `10px solid ${
          isSuccess
            ? "#2fc448"
            : isLoading
            ? "#043676"
            : isError
            ? "#EC0020"
            : "#2fc448"
        }`,
        backgroundColor: "#fafafa",
      }}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <img src={isError ? themeError : themeImage} alt="user-feedback" />
      )}
      <div className="user-feedback-text-container">
        <label>{title}</label>
        <p>{message}</p>
      </div>
      <div className="close-icon-container" onClick={handleExit}>
        <img src={themeClose} alt="user-feedback" />
      </div>
    </div>
  );
};

export { UserFeedback };
